import { Pipe } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { KompaktdarstellungPipe } from '../../shared/kompaktdarstellung/kompakt-darstellung.pipe';
import { FormatConfigService } from '../../core/services/format-config.service';
import { ComponentLocationStrategy } from '../../shared/services/location-strategy/component-location-strategy';
import { GebaeudeEingangAdresseListEntry } from '../../core/gwr-api';
import { TranslateNamePipe } from '../../shared/pipes/simple/translate-name.pipe';

@Pipe({
  name: 'kompaktGwrGebaeudeeingangsadresse'
})
export class KompaktGwrGebaeudeeingangsadressePipe extends KompaktdarstellungPipe<GebaeudeEingangAdresseListEntry> {
  constructor(
    protected formatConfigService: FormatConfigService,
    protected location: PlatformLocation,
    protected kompaktLocation: ComponentLocationStrategy,
    private translateName: TranslateNamePipe
  ) {
    super(formatConfigService, 'GEBAEUDEEINGANGSADRESSE', location, kompaktLocation);
  }

  transform(adresse: GebaeudeEingangAdresseListEntry): string {
    if (!adresse) {
      return '';
    }
    return this.getDefaultFormat(adresse);
  }

  getDefaultFormat(adresse: GebaeudeEingangAdresseListEntry) {
    const strasseName = this.translateName.transform(adresse.strasse);
    const strasseHausnummer = [strasseName, adresse.hausnummer].filter((val) => val).join(' ');
    const ortschaft = [adresse.plz, adresse.ortschaft].filter((val) => val).join(' ');
    return [strasseHausnummer, ortschaft].filter((val) => val).join(', ');
  }
}
